import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";

const IncentiveCCAApproval = () => {
  const initialFormData = [
    {
      PayrollMonthID: null,
      ApplicationStatus_123: null,
      ActionRemark: "",
    },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Incentive & CCA Approval"));
    fetchIncentiveApproval();
    fetchPayrollMonth();
  }, []);

  const [formData, setFormData] = useState(initialFormData);
  const [incentiveApproval, setIncentiveApproval] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [payrollList, setPayrollList] = useState([]);
  const [selectedID, setSelectedID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [errors, setErrors] = useState({});

  const columns = {
    Employee: { text: "Employee", visible: true },
    Type: { text: "Type", visible: true },
    Project: { text: "Project", visible: true },
    InvoiceDate: { text: "Invoice Date", align: "center", visible: true },
    City: { text: "City", visible: true },
    Amount: { text: "Amount", align: "end", visible: true },
    PayrollMonth: { text: "Payroll Month", align: "center", visible: true },
    ApplicationStatus: { text: "Status", align: "start", visible: true },
  };
  const fetchIncentiveApproval = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/incentive&CCA/incentive-cca-approval-list`
      );
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const data = response?.data?.data;
        setIncentiveApproval(data);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const fetchPayrollMonth = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/incentive&CCA/get-employee-payroll-months`
      );

      if (response?.status === 200) {
        // Type Options
        const payroll = response?.data?.data;
        const payrollOpt = payroll.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setPayrollList(payrollOpt);
      }
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  const handleApprove = (id) => {
    const matchedPayroll = payrollList?.find(
      (item) => item.label === id?.PayrollMonth
    );
    setFormData({
      ...formData,
      PayrollMonthID: matchedPayroll?.value || null,
      ApplicationStatus_123: id?.ApplicationStatus_123,
    });
    // Pass the ID directly to handleSubmit
    setSelectedID(id.ID);
    setShowModal(true);
  };
  const handleReject = (id) => {
    const matchedPayroll = payrollList?.find(
      (item) => item.label === id?.PayrollMonth
    );
    setFormData({
      ...formData,
      PayrollMonthID: matchedPayroll?.value || null,
      ApplicationStatus_123: 827,
    });
    setSelectedID(id.ID);
    setShowModal(true);
  };

  const schema = Yup.object().shape({
    PayrollMonthID: Yup.number()
      .typeError("Project is required")
      .required("Project is required")
      .nullable(),
  });

  // const handleSubmit = async (event) => {
  //   // Ensure `event` is a valid object with preventDefault
  //   if (event && event.preventDefault) {
  //     event.preventDefault();
  //   }
  //   setLoading(true);

  //   // Check if required fields are provided
  //   if (formData?.PayrollMonthID || formData?.ActionRemark || selectedID) {
  //     try {
  //       // Prepare data with only the necessary fields
  //       const dataToSubmit = {
  //         ApplicationStatus_123: formData?.ApplicationStatus_123,
  //         PayrollMonthID: formData?.PayrollMonthID,
  //         ActionRemark: formData?.ActionRemark,
  //       };

  //       // API call
  //       const response = await PostFormServiceCaller(
  //         `${API_URL}payroll/incentive&CCA/incentive-cca-approval/${selectedID}`,
  //         dataToSubmit,
  //         "post"
  //       );

  //       console.log("Form submitted successfully:", response?.data);
  //       setShowModal(false);
  //       fetchPayrollMonth();
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         PayrollMonthID: null,
  //         ActionRemark: "",
  //       }));
  //       window?.location?.reload();
  //       setLoading(false);
  //     } catch (error) {
  //       console.error(
  //         "Error submitting form:",
  //         error?.response?.data || error.message
  //       );
  //     }
  //   } else {
  //     console.log("Please fill in all required fields.");
  //   }
  // };
  const handleSubmit = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    setLoading(true);

    try {
      // Validate the form data using Yup schema
      await schema.validate(formData, { abortEarly: false });

      // Prepare data with only the necessary fields
      const dataToSubmit = {
        ApplicationStatus_123: formData?.ApplicationStatus_123,
        PayrollMonthID: formData?.PayrollMonthID,
        ActionRemark: formData?.ActionRemark,
      };

      // API call
      const response = await PostFormServiceCaller(
        `${API_URL}payroll/incentive&CCA/incentive-cca-approval/${selectedID}`,
        dataToSubmit,
        "post"
      );
      setShowModal(false);
      fetchPayrollMonth();
      setFormData((prevState) => ({
        ...prevState,
        PayrollMonthID: null,
        ActionRemark: "",
      }));
      window?.location?.reload();
      setLoading(false);
    } catch (error) {
      if (error?.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors); // Store validation errors in state
      }
      console.error(
        "Error submitting form:",
        error?.response?.data || error.message
      );
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={incentiveApproval}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              showIcon1={true}
              showIcon2={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isActionRequired={true}
              handleIcon1={handleApprove}
              handleIcon2={handleReject}
              icons={{
                Icon1: <i className="fa fa-check"></i>,
                Icon1Text: "Verify",
                Icon1Flag: ["canVerify", "canApprove"],
                Icon2: <i className="fa fa-close"></i>,
                Icon2Text: "Reject",
                Icon2Flag: "canReject",
              }}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  {formData?.ApplicationStatus_123 === 824 ? (
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#27568B",
                        margin: "0",
                      }}
                    >
                      Verify Incentive and CCA
                    </p>
                  ) : formData?.ApplicationStatus_123 === 825 ? (
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#27568B",
                        margin: "0",
                      }}
                    >
                      Approve Incentive and CCA
                    </p>
                  ) : formData?.ApplicationStatus_123 === 827 ? (
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#27568B",
                        margin: "0",
                      }}
                    >
                      Reject
                    </p>
                  ) : null}
                </p>
                <button
                  className="custom-btn"
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#000",
                    padding: "4px",
                    borderRadius: "4px",
                    transition: "all 0.2s",
                    lineHeight: "1",
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="modal-body p-2">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div class="mb-3">
                      <label for="Code" class="form-label">
                        Payroll Month<span className="required">*</span>
                      </label>
                      <Select
                        value={payrollList?.find(
                          (o) => o.value === formData?.PayrollMonthID
                        )}
                        options={[
                          { value: null, label: "Select" },
                          ...payrollList,
                        ]}
                        className={` ${
                          errors.PayrollMonthID ? "is-invalid" : ""
                        }`}
                        name="PayrollMonthID"
                        onChange={(selectedOption) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            PayrollMonthID: selectedOption?.value || null,
                          }));
                        }}
                      />
                      {errors.PayrollMonthID && (
                        <div className="invalid-feedback">
                          {errors.PayrollMonthID}
                        </div>
                      )}
                    </div>
                    <div className="col-md-12">
                      <textarea
                        type="text"
                        className="form-control"
                        id="ActionRemark"
                        aria-describedby="ActionRemark"
                        name="ActionRemark"
                        placeholder="Remark"
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            ActionRemark: e.target.value,
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="text-end mt-2">
                    <button
                      type="button"
                      className="cancel-btn-sm me-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="custom-btn-sm">
                      {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IncentiveCCAApproval;
